import { render } from "./NavigationTabs.vue?vue&type=template&id=470a0ca0"
import script from "./NavigationTabs.js?vue&type=script&lang=js"
export * from "./NavigationTabs.js?vue&type=script&lang=js"

import "./NavigationTabs.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/korean-handbook/korean-handbook/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__